export default __webpack_public_path__ + "static/media/money.7eeeec7c.png";